var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', [_vm._l(_vm.localIdentityCardParent.list, function (item, i) {
    return _c('v-col', {
      key: i,
      attrs: {
        "cols": "12"
      }
    }, [_c('IdentityCardDocComponent', {
      attrs: {
        "index": i,
        "item": item
      },
      on: {
        "set-data": function setData($event) {
          return _vm.setIdentityCard($event, item);
        },
        "remove": function remove($event) {
          return _vm.removeIdentityCard(item);
        }
      }
    })], 1);
  }), !_vm.localIdentityCardParent.list.length ? _c('v-col', {
    staticClass: "d-flex justify-end pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "outlined": "",
      "rounded": ""
    },
    on: {
      "click": _vm.addIdentityCard
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v(" mdi-plus ")]), _vm._v(" Добавить документ удостоверяющий личность ")], 1)], 1) : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }